import React from 'react';
import styles from './Breadcrumb.module.css';

interface BreadcrumbItem {
  label: string;
  href?: string;
  current?: boolean;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  return (
    <div className="container mx-auto px-4 py-4">
      <nav className="text-sm">
        <ul className="flex items-center space-x-2 text-neutral">
          {items.map((item, index) => (
            <React.Fragment key={index}>
              {index > 0 && <li className="text-neutral/75">/</li>}
              <li>
                {item.current ? (
                  <span className="text-neutral font-medium">
                    {item.label.toUpperCase()}
                  </span>
                ) : item.href ? (
                  <a
                    href={item.href}
                    className={`hover:text-primary transition-colors ${styles.breadcrumbLink}`}
                  >
                    {item.label.toUpperCase()}
                  </a>
                ) : (
                  <span className="text-neutral/75">
                    {item.label.toUpperCase()}
                  </span>
                )}
              </li>
            </React.Fragment>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default Breadcrumb;
